// @flow

export const FETCH_FAQ_CATEGORIES: string = 'FETCH_FAQ_CATEGORIES';
export const FETCH_FAQ_CATEGORIES_SUCCESS: string = 'FETCH_FAQ_CATEGORIES_SUCCESS';
export const FETCH_FAQ_CATEGORIES_FAILURE: string = 'FETCH_FAQ_CATEGORIES_FAILURE';

export const FETCH_FAQ_CATEGORY_QUESTIONS: string = 'FETCH_FAQ_CATEGORY_QUESTIONS';
export const FETCH_FAQ_CATEGORY_QUESTIONS_SUCCESS: string = 'FETCH_FAQ_CATEGORY_QUESTIONS_SUCCESS';
export const FETCH_FAQ_CATEGORY_QUESTIONS_FAILURE: string = 'FETCH_FAQ_CATEGORY_QUESTIONS_FAILURE';
